import axios from "axios";

import { handleRequestError } from "@/components/Utils/handleRequestError";

export async function GET_TAGS(params) {
  const url = `/api/v1/tags/`;
  try {
    const resp = await axios.get(url, { params });
    return resp.data;
  } catch (error) {
    handleRequestError(error);
  }
}

export async function CREATE_TAG(data) {
  const url = `/api/v1/tags/`;
  try {
    const resp = await axios.post(url, data);
    return resp.data;
  } catch (error) {
    handleRequestError(error);
  }
}

export async function DELETE_TAG(tag) {
  const url = `/api/v1/tags/${tag.id}`;
  try {
    const resp = await axios.delete(url);
    return resp.data;
  } catch (error) {
    handleRequestError(error);
  }
}

export async function UPDATE_TAG(tag, data) {
  const url = `/api/v1/tags/${tag.id}/`;
  try {
    const resp = await axios.patch(url, data);
    return resp.data;
  } catch (error) {
    handleRequestError(error);
  }
}
